import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { setT } from 'helpers/translationUtilities';
FacilitatorTemplateForm.propTypes = {
    onTitleChange: PropTypes.func,
    onDateTimeChange: PropTypes.func
};
export default function FacilitatorTemplateForm(_a) {
    var _b = _a.onTitleChange, onTitleChange = _b === void 0 ? null : _b, _c = _a.onDateTimeChange, onDateTimeChange = _c === void 0 ? null : _c;
    var _d = useState(new Date()), selectedDate = _d[0], setSelectedDate = _d[1];
    function onFieldChange(_a) {
        var target = _a.target;
        if ((target === null || target === void 0 ? void 0 : target.name) === 'title')
            onTitleChange(target.value);
    }
    function handleDateChange(date) {
        setSelectedDate(date);
        if (onDateTimeChange) {
            onDateTimeChange(Math.floor(date.getTime() / 1000).toString());
        }
    }
    return (React.createElement("div", { className: "form-control" },
        React.createElement("div", { className: "form-control__full" },
            React.createElement("div", { className: "form-control__group" },
                React.createElement("div", { className: "form-control__label" }, setT('title')),
                React.createElement("input", { type: "text", name: "title", className: "basic-input", onChange: onFieldChange })),
            React.createElement("div", { className: "form-control__group" },
                React.createElement("div", { className: "form-control__label" }, setT('date')),
                React.createElement(DatePicker, { selected: selectedDate, onChange: handleDateChange, showTimeSelect: true, dateFormat: "dd-MM-yyyy HH:mm", timeFormat: "HH:mm", timeIntervals: 1, className: "basic-input" })))));
}
